import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "llgreyBg ddgrey",
  style: {"padding":"6px 11px","left":"50%","transform":"translateX(-50%)","border-radius":"12px","box-shadow":"0 8px 24px rgba(0, 0, 0, 0.25)"}
}
const _hoisted_2 = {
  class: "with_white_bg pad20",
  style: {"width":"320px"}
}
const _hoisted_3 = {
  key: 0,
  class: "fw600 w100 fs16 mb5 text-center"
}
const _hoisted_4 = {
  key: 1,
  class: "fw600 w100 fs11 mt10 text-center"
}
const _hoisted_5 = {
  key: 2,
  class: "text-left fs13"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["href", "onClick"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["href", "onClick"]
const _hoisted_11 = { key: 2 }
const _hoisted_12 = ["href"]
const _hoisted_13 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.mag.team_name)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.mag.team_name), 1))
        : _createCommentVNode("", true),
      (_ctx.mag.description)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, "紹介文"))
        : _createCommentVNode("", true),
      (_ctx.mag.description)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.autoLink(_ctx.mag.description, true), (text, textindex) => {
              return (_openBlock(), _createElementBlock("span", {
                key: `${text}${textindex}`
              }, [
                (text.match(_ctx.TemplateUtil.buttonRegex) || text.match(_ctx.TemplateUtil.buttonRegexWithOptions))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                      _createElementVNode("button", {
                        href: `${text.match(_ctx.TemplateUtil.buttonLinkRegex)[0].replace(`(`, ``).split(`)`)[0]}`,
                        class: _normalizeClass(`w100 pad5 skyblueBorder l2 with_white_bg centered fw600 rad8 hoverGrey`),
                        rel: "noopener noreferrer",
                        style: {},
                        onClick: ($event: any) => (_ctx.clickButtonLink(text))
                      }, [
                        _createElementVNode("span", null, _toDisplayString(text.match(_ctx.TemplateUtil.buttonTextRegex)[0].replace(`[`, ``).replace(`]`, ``)), 1),
                        _hoisted_8
                      ], 8, _hoisted_7)
                    ]))
                  : (text.match(_ctx.TemplateUtil.regex))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                        _createElementVNode("a", {
                          href: text,
                          class: _normalizeClass(`innerLink skyblue fw600 ${_ctx.isSP ? `fs12` : ``}`),
                          target: "_blank",
                          rel: "noopener noreferrer nofollow",
                          style: {"text-decoration":"underline"},
                          onClick: ($event: any) => (_ctx.clickInnerMessage(text))
                        }, _toDisplayString(text), 11, _hoisted_10)
                      ]))
                    : (
                            text.match(_ctx.TemplateUtil.telRegex1) ||
                            text.match(_ctx.TemplateUtil.telRegex2) ||
                            text.match(_ctx.TemplateUtil.telRegex3)
                        )
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                          _createElementVNode("a", {
                            href: `tel:${text}`,
                            class: _normalizeClass(`innerLink skyblue fw600 ${_ctx.isSP ? `fs12` : ``}`),
                            target: "_blank",
                            rel: "noopener noreferrer",
                            style: {"text-decoration":"underline"}
                          }, _toDisplayString(text), 11, _hoisted_12)
                        ]))
                      : (_openBlock(), _createElementBlock("span", {
                          key: 3,
                          class: "fw600",
                          style: {"line-height":"1.6"},
                          innerHTML: text
                        }, null, 8, _hoisted_13))
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}